export const schema = {
  type: "object",
  properties: {
    productname: { type: "string" },
    productfamily: { type: "string" },
    productcode: { type: "string" },
    active: { type: "boolean" },
    productdescription: { type: "string" },
  },
};
